import { Segmented } from "antd";
import React, { useState } from "react";
import s from "./Keys.module.scss";
import InvalidKeys from "../InvalidKeys";
import RevokedKeys from "../RevokedKeys";
function Keys() {
  const [type, setType] = useState<string>("inactive keys");

  return (
    <div className={s.wrapper}>
      <div className={s.head}>
        <Segmented<string>
          options={["Inactive Keys", "Revoked keys"]}
          onChange={(value) => {
            setType(value.toLowerCase());
          }}
          className="custom-segmented"
          //value={value}
        />
      </div>
      {type === "inactive keys" ? <InvalidKeys /> : <RevokedKeys />}
    </div>
  );
}

export default Keys;
